// extracted by mini-css-extract-plugin
export default {"cartAmount":"CartAmount_cartAmount__X8TjR"};